import { HttpService } from "../core/http";
import { Injectable } from '@angular/core';
import { IIdName } from '../_entities';
import { ModelStateValidationService } from "./model-state-validation.service";

@Injectable()
export class ContractTemplateService {

    private templates: any = {};

    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
    }

    get guarantee(): Promise<IIdName[]> {
        return this.getTemplates("guarantee");
    }

    get contractType(): Promise<IIdName[]> {
        return this.getTemplates("type");
    }

    get contractStatus(): Promise<IIdName[]> {
        return this.getTemplates("status");
    }

    get unitClass(): Promise<IIdName[]> {
        return this.getTemplates("unitClass");
    }

    private getTemplates(name: string): Promise<IIdName[]> {
        if (!this.templates.hasOwnProperty(name)) {
			this.templates[name] = this.httpService.get<IIdName[]>(`api/contract/templates/${name}`)
                .catch(e => this.validationService.handleError(e));
        }
        return this.templates[name];
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/contract-template.service.ts